import { useState } from 'react';
import Input from '../../components/Input';
import axios from "axios";
import { appId, ticketBaseURL } from '../../config/api';
import { Helmet } from 'react-helmet-async';

const Careers = () => {
  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  const onChangePhoneNumber = (value: string) => {
    const { length } = value;
    const regex = () => value.replace(/[^\d.]+/g, '');
    const areaCode = () => `(${regex().slice(0, 3)})`;
    const firstSix = () => `${areaCode()} ${regex().slice(3, 6)}`;
    const trailer = (start: number) => `${regex().slice(start, regex().length)}`;
    if (length < 3) setPhone(regex());
    else if (length >= 3 && length < 10) setPhone(`${areaCode()} ${trailer(3)}`);
    else if (length === 5) setPhone(`${areaCode().replace(")", "")}`);
    else if (length >= 10 && length < 15) setPhone(`${firstSix()}-${trailer(6)}`);
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isProcessing) return;
    setIsProcessing(true);

    await axios
      .post(
        `${ticketBaseURL}customerEnquiry`,
        JSON.stringify({
          email,
          name,
          question: message,
          applicationId: appId,
          phone,
          created: new Date(),
        }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      )
      .then(() => {
        resetForm();
        setSubmitted(true);
        setIsProcessing(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsProcessing(false);
      });
  };

  const resetForm = () => {
    setEmail("");
    setName("");
    setPhone("");
    setMessage("");
  };

  return (
    <div className="bg-[#F4F5FA] w-full flex flex-col">
      <Helmet>
        <title>Careers at Data Repo | Software Development Jobs</title>
        <meta
          name="description"
          content="Join Data Repo and build innovative software and AI solutions. Explore career opportunities in web development, mobile apps, artificial intelligence, and technology consulting."
        />
      </Helmet>

      <section className="hero--container relative flex flex-col justify-center w-full h-[60vh] bg-[#1E293B] pt-[65px]">
        <h1 className="text-center text-white text-3xl md:text-5xl font-bold uppercase">Careers at Data Repo</h1>
        <p className="text-center text-white text-lg md:text-xl mt-4 px-6 md:px-0">
          Join our team and help us build innovative data solutions. We are always looking for talented and motivated individuals!
        </p>
      </section>

      <section className="w-full py-10 bg-white">
        <div className="max-w-screen-lg mx-auto px-5 md:px-1 py-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Current Openings & Career Opportunities
          </h2>
          <p className="text-gray-700 text-lg mb-6">
            Submit your application and our recruitment team will contact you regarding software development career opportunities.
          </p>
        </div>

        <div className="flex justify-center items-center">
          <form className="flex flex-col gap-4 w-9/12 max-w-2xl" onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row gap-4">
              <Input
                type="text"
                label="Full Name"
                pattern=""
                title=""
                inputValue={name}
                setInputValue={setName}
              />
              <Input
                type="email"
                label="Email Address"
                pattern=""
                title=""
                inputValue={email}
                setInputValue={setEmail}
              />
            </div>

            <Input
              type="text"
              label="Phone Number"
              pattern="[\(][0-9]{3}[\)][\s]{1}[0-9]{3}[\-]{1}[0-9]{4}"
              title="Please enter a valid 10-digit number."
              inputValue={phone}
              setInputValue={onChangePhoneNumber}
            />

            <div className="w-full">
              <textarea
                name="message"
                className="peer h-32 w-full rounded border border-gray-200 px-3 py-2 font-sans text-sm text-gray-700 outline-none focus:border-2 focus:border-gray-400"
                placeholder="Tell us about your skills, experience, and the role you’re interested in."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
            </div>

            {submitted && (
              <div className="text-center text-green-600 font-semibold">
                Thank you! Your application has been submitted.
              </div>
            )}

            <div className="flex justify-center">
              <button
                type="submit"
                className="bg-slate-500 hover:bg-slate-700 text-white font-semibold py-4 px-8 rounded uppercase"
              >
                {isProcessing ? "Submitting..." : "Submit Application"}
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}

export default Careers;